<template>
  <div>
    <div class="loader center-loader" v-if="isLoading"></div>
    <div v-else>
      <Login v-if="!isLoggedIn" :isLoggedIn.sync="isLoggedIn"></Login>
      <div v-else>
        <div class="loader center-loader" v-if="!profile"></div>
        <div class="landing-group" v-else>
          <TopBar></TopBar>
          <div class="nav-group">
            <Nav
              :profile="profile"
              :items="navItems"
              :selectedNav.sync="selectedNav"
              :bgColor="'#0a1a52'"
              :isLoggedIn.sync="isLoggedIn"
            >
              <template v-slot:content>
                <!-- dynamic component, will be changed according to the selectedNav, refer to the ids in navItems() -->
                <component
                  :is="selectedNav"
                  :profile="profile"
                  :selectedNav.sync="selectedNav"
                ></component>
              </template>
              <template v-slot:logo>
                <img class="bottom-logo" src="./assets/logo-biblio.png" alt />
              </template>
              <template v-slot:footer>
                <div style="font-size: 0.9em; color: rgb(203, 205, 205)">
                  &copy; 2019 Copyright School System v 1.18 by
                  <a>BIBLIO</a>
                </div>
              </template>
            </Nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'normalize.css';
import { http } from './digilib_web/core/digitify';
import { constants } from './js/regents';
import Nav from './digilib_web/vue/navbar';
import TopBar from './components/topbar';
import StaffDetails from './components/staff';
import StaffPayslips from './components/staff_payslips';
import StaffAttendance from './components/staff_attendance';
import PendingRequests from './components/pending_requests';
import MyDetails from './components/my_details';
import MyPayslips from './components/my_payslips';
import MyAttendance from './components/my_attendance';
import MyTimeoff from './components/my_timeoff';
import Login from './components/login';
import Dashboard from './components/dashboard';
require('./digilib_web/core/digitify.css');

const PAGES = constants.NAV_PAGES;

export default {
  name: 'app',
  components: {
    Nav,
    TopBar,
    Login,
    Dashboard,
    MyPayslips,
    MyDetails,
    MyAttendance,
    MyTimeoff,
    StaffDetails,
    StaffPayslips,
    PendingRequests,
    StaffAttendance
  },
  mounted() {
    this.getProfile();
  },
  computed: {
    navItems() {
      let items = [
        {
          title: 'DASHBOARD',
          icon: 'fa fa-home',
          id: PAGES.DASHBOARD
        },
        {
          title: 'MY DETAILS',
          icon: 'far fa-user',
          id: PAGES.MY_DETAILS
        },
        {
          title: 'MY PAYSLIPS',
          icon: 'fas fa-money-check-alt',
          id: PAGES.MY_PAYSLIPS
        },
        {
          title: 'MY ATTENDANCE',
          icon: 'far fa-clock',
          id: PAGES.MY_ATTENDANCE
        },
        {
          title: 'MY TIME OFF',
          icon: 'far fa-calendar-check',
          id: PAGES.MY_TIMEOFF
        }
      ];
      if (this.profile.role === 'admin') {
        items.push(
          {
            title: 'STAFF DETAILS',
            icon: 'fas fa-users',
            id: PAGES.STAFF_DETAILS
          },
          {
            title: 'STAFF ATTENDANCE',
            icon: 'far fa-address-card',
            id: PAGES.STAFF_ATTENDANCE
          },
          {
            title: 'STAFF PAYSLIPS',
            icon: 'fas fa-money-check-alt',
            id: PAGES.STAFF_PAYSLIPS
          },
          {
            title: 'PENDING REQUESTS',
            icon: 'far fa-comment',
            id: PAGES.PENDING_REQUESTS
          }
        );
      } else if (this.profile.job_category === 'Principal') {
        items.push({
          title: 'PENDING REQUESTS',
          icon: 'far fa-comment',
          id: PAGES.PENDING_REQUESTS
        });
      }
      return items;
    }
  },
  methods: {
    getProfile() {
      let id = localStorage.getItem('regent_profile_id');
      if (id) {
        http
          .get(`profile/${id}`)
          .then(json => {
            // console.log(JSON.stringify(json.data[0]))
            if (json.success) {
              this.isLoggedIn = true;
              this.isLoading = false;
              this.profile = json.data[0];
              // roles return array e.g. ["Admin", "Staff"]
              if (id === 197 || id === '197') {
                this.profile.role = 'staff';
              } else {
                this.profile.role =
                  this.profile.roles.includes('Admin') ||
                  this.profile.roles.includes('Tester')
                    ? 'admin'
                    : 'staff';
              }
              // check the session the first time app starts
              // selectedNav will determine which nav tab is currently being loaded
              let nav = sessionStorage.getItem('nav');
              this.selectedNav = nav || PAGES.DASHBOARD;
            }
          })
          .catch(err => {
            if (err === 401) {
              this.isLoggedIn = false;
              this.isLoading = false;
            }
          });
      } else {
        this.isLoggedIn = false;
        this.isLoading = false;
      }
    }
  },
  watch: {
    selectedNav: {
      handler(id) {
        sessionStorage.setItem('nav', id);
      }
    },
    isLoggedIn: {
      handler(loggedIn) {
        if (!loggedIn) {
          this.profile = null;
          sessionStorage.removeItem('nav');
          localStorage.removeItem('regent_profile_id');
          http.get('logout');
        } else {
          this.getProfile();
        }
      }
    }
  },
  data() {
    return {
      isLoading: true,
      isLoggedIn: false,
      selectedNav: null,
      profile: null
    };
  }
};
</script>

<style>
.bottom-logo {
  width: 144px;
  height: 48px;
}
.center-loader {
  position: absolute;
  left: 50%;
  margin-right: -50%;
  top: 50%;
}
.container-root {
  padding: 8px;
}
.landing-group {
  display: flex;
  flex-flow: column;
  height: 100vh;
}
.nav-group {
  height: 93%;
}
.padding {
  padding: 10px;
}
.button {
  display: flex;
  height: 30px;
  border: none;
  border-radius: 20px;
  padding: 7px 12px 12px;
  font-size: 1em;
  color: white;
  cursor: pointer;
}
.button-square {
  color: white;
  border: none;
  background: #39a2d9;
  border-radius: 4px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  padding: 0.5rem 1rem;
  transition: 0.2s ease-out;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  cursor: pointer;
}
.dark-blue {
  background: #203368;
}
.green {
  color: #36d7b7;
  background: white;
  border: 1px solid #36d7b7;
}
.green-bg {
  background: #36d7b7;
}
.green-col {
  color: #36d7b7;
}
.red {
  background: #cf000f;
}
.red-col {
  color: #cf000f;
}
.blue-col {
  color: #39a2d9;
}
.upload {
  background-color: #39a2d9;
  padding: 5px;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}
.upload-text {
  margin-left: 10px;
  font-weight: bold;
}
@media all and (max-width: 768px) {
  .padding {
    padding: 0;
  }
  .nav-group {
    height: 100%;
  }
  .container-root {
    padding: 10px;
  }
}
</style>
